<template>
  <form-section id="contract_deatils" :headline="$t('form.contract_details.headline')">
    <div class="form-group">
      <label>{{ $t("form.contract_details.contract_type.label") }}</label>
      <div class="inline-lg">
        <div class="form-check">
          <label>
            <input :value="true" v-model="contractDetails.isDistributor" type="radio" name="contractType" />
            {{ $t("form.contract_details.contract_type.distributor_label") }}
          </label>
        </div>
        <div class="form-check">
          <label>
            <input :value="false" v-model="contractDetails.isDistributor" type="radio" name="contractType" />
            {{ $t("form.contract_details.contract_type.supplier_label") }}
          </label>
        </div>
      </div>
    </div>

    <datepicker-wrapper id="agreement_date_input" :label="this.$t('form.contract_details.agreement_date.label')">
      <datepicker
        id="agreement_date_input"
        input-class="form-control datepicker"
        :placeholder="this.$t('form.contract_details.agreement_date.placeholder')"
        format="dd/MM/yyyy"
        @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
        v-on:input="formatDate($event)"
        :language="lang"
      ></datepicker>
    </datepicker-wrapper>
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection.vue";
import RadioGroup from "@/shared/components/RadioGroup.vue";
import DatepickerWrapper from "@/shared/components/DatepickerWrapper.vue";
import { format } from "date-fns";
import Datepicker from "vuejs-datepicker";
import { da } from "vuejs-datepicker/dist/locale";

export default {
  components: {
    FormSection,
    RadioGroup,
    DatepickerWrapper,
    Datepicker
  },
  data() {
    return {
      lang: da,
      contractDetails: {
        isDistributor: true,
        agreementDate: ""
      }
    };
  },
  computed: {
    contractTypeOptions() {
      return [this.$t("form.contract_details.contract_type.distributor_label"), this.$t("form.contract_details.contract_type.supplier_label")];
    },
    distributorOption() {
      return this.$t("form.contract_details.contract_type.distributor_label");
    },
    supplierOption() {
      return this.$t("form.contract_details.contract_type.supplier_label");
    }
  },
  methods: {
    formatDate(e) {
      this.contractDetails.agreementDate = format(e, "DD/MM/YYYY"); // THIS IS A HACK, but datepicker is funky with 2-way binding when used as component, so this is doing for now (TODO: Handle dateformatting in contract components)
    }
  },
  watch: {
    contractDetails: {
      handler() {
        this.$store.commit("updateContractDetails", this.contractDetails);
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/ContractDetails.vue